import { ITranslatedFunction } from "@services/i18n"
import { CheckboxState } from "@components/Checkbox"

export function getBulkSelectionTitle(checked: CheckboxState): ITranslatedFunction<string> {
	return (t) => {
		return checked === CheckboxState.Unchecked ? t("bulkActions.select") : t("bulkActions.deselect")
	}
}
